import { Controller } from '@hotwired/stimulus';

/**
 * Controlador "fake" para el slider de pagadores
 */
export default class extends Controller {
  connect() {
    /* global init_payment_percentage_slider */
    const { selectorSlider } = this.element.dataset;

    if (!selectorSlider) {
      throw new Error('Hay que configuar el atributo data-selector-slider');
    }

    init_payment_percentage_slider(selectorSlider, `${selectorSlider}-resume`);
    // init_payment_percentage_slider(
    //   '.porcentaje-pago-usuario-slider',
    //   '.porcentaje-pago-usuario-slider-resume'
    // );
  }
}
